// extracted by mini-css-extract-plugin
export default {"btn":"login_btn__AbdC0"};